import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Divider from '@material-ui/core/Divider'
import { API } from '@const'
import * as utils from '@utils'
import PfSubPfSelect from '@select/pf-sub-pf-select'
import { Line } from 'react-chartjs-2'

class OperationOverviewPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'OperationOverviewPage')
        }
    }

    state = {
        data: {
            labels: [],
            datasets: [
                {
                    label: '留存率(%)',
                    fill: true,
                    lineTension: 0.1,
                    backgroundColor: 'rgba(75,192,192,0.4)',
                    borderColor: 'rgba(75,192,192,1)',
                    borderCapStyle: 'butt',
                    borderDash: [],
                    borderDashOffset: 0.0,
                    borderJoinStyle: 'miter',
                    pointBorderColor: 'rgba(75,192,192,1)',
                    pointBackgroundColor: '#fff',
                    pointBorderWidth: 1,
                    pointHoverRadius: 10,
                    pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                    pointHoverBorderColor: 'rgba(220,220,220,1)',
                    pointHoverBorderWidth: 2,
                    pointRadius: 5,
                    pointHitRadius: 10,
                    data: [],
                },
            ],
        },
    }

    queryData() {
        const params = {
            pf_id: this.pfSelect.state.pfId,
            pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
        }

        utils.apiRequest(
            'get',
            API.RETENTION_REPORTS,
            params,
            (dataList) => {
                const dates = dataList.map((d) => new Date(d.date).toLocaleDateString())
                const rates = dataList.map((d) => (d.retained_rates * 100).toFixed(2))
                const data = this.state.data
                data.labels = dates
                data.datasets[0].data = rates

                this.setState({
                    data,
                })
            },
            () => {
                this.setState({
                    data: {
                        ...this.state.data,
                        datasets: [{ ...this.state.data.datasets[0], data: [] }],
                    },
                })
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <PfSubPfSelect
                    onRef={(ref) => (this.pfSelect = ref)}
                    options={{
                        subPfChangeCallback: () => {
                            this.queryData()
                        },
                        hideCurrency: true,
                    }}></PfSubPfSelect>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={10}>
                    <Line data={this.state.data} />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        textField: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
    }
}

OperationOverviewPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default hoc(styles)(OperationOverviewPage)
